export default "/images/458001282cbbaeb0af75731dde6369f5.jpg";